module.exports = __webpack_public_path__ + "img/trends_4.4a0938ea.jpg";